import { CSSProperties } from 'react';

export const appendStyles = (elements: HTMLElement[], styles: CSSProperties) => {
    elements.forEach((element) => {
        Object.entries(styles).forEach(([styleProp, style]) => {
            element.style[styleProp as any] = style;
        });
    });
};
